module.exports = __webpack_public_path__ + "static/media/Тезисы_УОМШ-2021_Том_1.36add0d4.pdf";